import { MissionPartial } from '../../../lib/types/models/mission/mission'
import { TripBookingDispatchPlaceIndividualTypeEnum } from '../../../lib/types/models/trip-booking/trip-date'
import { TripBookingDispatchPlaceBasic } from '../../../lib/types/models/trip-booking-dispatch-places/trip-booking-dispatch-place'

export const calculateAffectedPlaces = (
  missions: MissionPartial[],
  tripBookingDispatchPlaces: TripBookingDispatchPlaceBasic[]
) => {
  const totalStaff = missions
    .map((mission) => mission.affectedStaffs.length)
    .reduce((a, b) => a + b, 0)
  const totalLecStaff = missions
    .map((mission) => mission.affectedLecStaffs.length)
    .reduce((a, b) => a + b, 0)
  const totalExternalStaff = missions
    .map((mission) => mission.affectedExternalStaffs.length)
    .reduce((a, b) => a + b, 0)

  const numberOfAffectedStudents = tripBookingDispatchPlaces.filter(
    (place) =>
      place.id && place.individualType === TripBookingDispatchPlaceIndividualTypeEnum.ENROLLMENT
  ).length

  const totalNumberOfAffectedStaff = totalStaff + totalLecStaff + totalExternalStaff
  return `${numberOfAffectedStudents} + ${totalNumberOfAffectedStaff}`
}
